
import api from './api';
import auth from './auth';
import env from './env';
import menu from './menu';
import network from './network';
import notifications from './notifications';
import panels from './panels';
import popovers from './popovers';
import time from './time';
import viewport from './viewport';

export {
	api,
	auth,
	env,
	menu,
	network,
	notifications,
	panels,
	popovers,
	time,
	viewport
};

export default {
	api,
	auth,
	env,
	menu,
	network,
	notifications,
	panels,
	popovers,
	time,
	viewport
};



// WEBPACK FOOTER //
// ./src/services/index.js